import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import ChevronLeftIcon from 'components/ChevronLeftIcon'

const CloseButton = ({ onClose, className, Icon, ...rest }) =>
  onClose ? (
    <div className={classnames('absolute top-4 left-4 md:left-6', className)} {...rest}>
      <button
        type="button"
        className="form-button w-6 h-6 bg-markoBlack rounded-full flex justify-center items-center"
        onClick={onClose}
      >
        <Icon className="text-white w-3 h-3" />
      </button>
    </div>
  ) : null

CloseButton.defaultProps = {
  Icon: ChevronLeftIcon,
  className: 'left-4',
}

CloseButton.propTypes = {
  Icon: PropTypes.func,
  onClose: PropTypes.func,
  className: PropTypes.string,
  position: PropTypes.string,
}

export default CloseButton
